export default function HeroSection() {
  return (
    <section className="relative min-h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9033cdb9269ed223855ff16d8809e514.jpg"
          alt="TRex RE LLC Office"
          className="w-full h-full object-cover object-top"
          onError={(e) => {
            const target = e.currentTarget as HTMLImageElement;
            target.style.display = 'none';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-32">
        <div className="mb-8 flex justify-center">
          <img
            src="https://static.readdy.ai/image/4f005a6d9d587cd5cd5ab19a1efc7d16/e6bc1268a18391062efc3c74a05c24f8.png"
            alt="TRex RE LLC Logo"
            className="w-full max-w-[300px] h-auto"
          />
        </div>
        <h1
          className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight"
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          About <strong>TRex RE LLC</strong>
        </h1>
        <p className="text-xl md:text-2xl text-white/90 leading-relaxed">
          El Paso's trusted cash home buyers since 2016. We buy houses in any
          condition, helping homeowners sell fast without the hassle. We also help people lease properties and match them to the right home or apartment in our portfolio.
        </p>
      </div>
    </section>
  );
}
